/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class XeroBatchesRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model() {
    return this.store
      .query('xero/batch', { schoolId: this.session.activeSchool })
      .then((batches) => {
        return hash({ batches });
      })
      .catch((error) => {
        return hash({ error });
      });
  }
}
